<!--
* 组件名 : 图片展示
* 开发者 : JY
*
* 参数:
*  image      { String }   required - 图片卡片
*  maxImage   { String }   required - 原始绘画图
*  desc       { String }   [] - 卡片信息
*  slug       { String }   [] - 卡片slug
*
* 事件:
* btnClick  []  -  点击图片打开图片管理器
*
-->

<template>
  <section class="v-float-image" ref="floatViewer">
    <div class="img-wrapper" ref="imgWrapper">
      <div class="viewer-canvas-box" ref="canvas">
        <v-img :path="image" :slug="slug" class="viewer-img" ref="img" />
        <v-btn class="picture-view-btn" @btnClick="open_paint_viewer">
          <v-icon class="material-icons-round">zoom_in</v-icon>
        </v-btn>
      </div>
    </div>
    <div class="img-info" v-html="desc" />
  </section>
</template>

<script>
export default {
  name: "v-float-image",
  props: {
    image: {
      type: String,
      required: true,
    },
    maxImage: {
      type: String,
      required: true,
    },
    desc: {
      type: String,
      default: null,
    },
    slug: {
      type: String,
      default: "",
    },
  },
  methods: {
    /**
     *  打开图片查看器
     */
    open_paint_viewer() {
      this.$paintViewer({
        carousel: [{ max: this.maxImage, slug: this.slug }],
      });
    },
  },
};
</script>

<style lang="scss">
.v-float-image {
  .img-wrapper {
    position: relative;
    width: 100%;

    img {
      max-width: 100%;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      margin: auto;
    }
  }

  .viewer-canvas-box {
    width: 100%;
    position: relative;
    padding-top: 74.5%;
    overflow: hidden;
    background-color: $color-placeholder;
    border-radius: 8px;
  }

  .img-info {
    margin-top: 20px;
    line-height: 1.4;
    color: $color-normal;
    padding: 0 8px;
  }

  .page-content-left {
    position: relative;
  }

  .page-content-left .loading {
    position: absolute;
    left: 0;
    right: 0;
    top: 30vh;
    margin: auto;
  }

  .picture-view-btn {
    position: absolute;
    right: 24px;
    bottom: 24px;
  }
}
</style>
